import styled from 'styled-components';
import { units, color } from '@m/alchemy-ui';

export const StyledDurationHeader = styled.div`
  display: flex;
  align-items: center;
  & svg {
    margin: 0 0 ${units(0.75)} ${units(0.5)};
  }
`;

export const StyledDurationRadio = styled.div`
  display: flex;
  align-items: center;
  padding-left: ${units(0.5)};
  gap: 8px;
  & input{
    width: 70px;
    min-width: 70px;
  }
  & .warning input, & .warning span::after, & .warning span::before {
    border-color: ${color('base', { palette: 'interactiveDestructive' })} !important;
  }
`;

export const StyledWcagWarning = styled.div`
  padding-left: ${units(0.5)};
  & svg {
    margin-right: ${units(1)};
  }
`;

export const StyledTargetingRadioWithWarning = styled.div`
  display: flex;
  flex-direction: column;
`;